import type { PropsWithChildren } from 'react';
import { IonHeader } from '@ionic/react';
import { cn } from '../../../lib/utils';

type AppSectionHeaderVariant = 'main' | 'fantasy' | 'admin';

const variantClasses: Record<AppSectionHeaderVariant, string> = {
  main: 'fc-app-section-header--main',
  fantasy: 'fc-app-section-header--fantasy',
  admin: 'fc-app-section-header--admin',
};

interface AppSectionHeaderProps extends PropsWithChildren {
  variant: AppSectionHeaderVariant;
  className?: string;
}

export const AppSectionHeader = ({
  variant,
  className,
  children,
}: AppSectionHeaderProps) => (
  <IonHeader
    className={cn(
      'fc-app-section-header',
      variantClasses[variant],
      className
    )}
  >
    {children}
  </IonHeader>
);
